import { Befehl26FormData, Befehl26FormSchema } from './schema'
import { Befehl26 } from '../../../models'
import {
  Befehl26DataDto,
  BefehlAuftrag_26_10Dto,
  BefehlAuftrag_26_12Dto,
  Feld_26_13Dto,
  Feld_26_14Dto,
  Feld_26_15Dto
} from '../../../dtos/befehl-26-dto'
import { findAuftragByKennung, hasAuftrag } from '../converter-utils'
import { Betriebsstellenart } from '../../../types'

export const convertModelToBefehl26FormData = (
  befehl?: Befehl26
): Befehl26FormData => {
  const formData = Befehl26FormSchema.parse({})

  if (!befehl?.auftraege) {
    return formData
  }

  const auftrag26_10 = findAuftragByKennung(
    befehl.auftraege,
    '26.10'
  ) as BefehlAuftrag_26_10Dto
  const feld26_14 = auftrag26_10?.felder?.find(
    (f) => f.kennung === '26.14'
  ) as Feld_26_14Dto
  const feld26_15 = auftrag26_10?.felder?.find(
    (f) => f.kennung === '26.15'
  ) as Feld_26_15Dto

  const auftrag26_12 = findAuftragByKennung(
    befehl.auftraege,
    '26.12'
  ) as BefehlAuftrag_26_12Dto
  const feld26_13 = auftrag26_12?.felder?.find(
    (f) => f.kennung === '26.13'
  ) as Feld_26_13Dto

  // enabled not changeable by user
  if (auftrag26_10) {
    formData.auftrag_26_10.enabled = true
    if (feld26_14?.werte?.km) {
      formData.auftrag_26_10.field_26_14_km = feld26_14.werte.km
    }

    if (feld26_15?.werte?.zugmeldestelle) {
      formData.auftrag_26_10.field_26_15 = {
        art: feld26_15.werte.zugmeldestelle.art || '',
        name: feld26_15.werte.zugmeldestelle.name || ''
      }

      // Business logic for des_der
      formData.auftrag_26_10.des_der = determineDesOrDerFromZugmeldestelleArt(
        feld26_15.werte.zugmeldestelle.art
      )
    }
  }

  if (hasAuftrag(befehl.auftraege, '26.11')) {
    formData.auftrag_26_11.enabled = true
  }

  if (auftrag26_12) {
    formData.auftrag_26_12.enabled = true
    if (feld26_13?.werte?.signal) {
      formData.auftrag_26_12.field_26_13_signal = feld26_13.werte.signal
    }
  }

  return formData
}

const determineDesOrDerFromZugmeldestelleArt = (
  zugmeldestelleArt: '' | Betriebsstellenart
): '' | 'des' | 'der' => {
  switch (zugmeldestelleArt) {
    case Betriebsstellenart.Bf:
    case Betriebsstellenart.Bft:
      return 'des'
    case Betriebsstellenart.Abzw:
    case Betriebsstellenart.Uest:
      return 'der'
    default:
      return ''
  }
}

export const convertBefehl26FormDataToModel = (
  formData: Befehl26FormData,
  frontendId: string
): Befehl26 => {
  const auftraege: Befehl26DataDto = []

  if (formData.auftrag_26_10?.enabled) {
    auftraege.push({
      kennung: '26.10',
      felder: [
        {
          kennung: '26.14',
          werte: { km: formData.auftrag_26_10?.field_26_14_km || '' }
        },
        {
          kennung: '26.15',
          werte: {
            zugmeldestelle: {
              art: formData.auftrag_26_10?.field_26_15?.art || '',
              name: formData.auftrag_26_10?.field_26_15?.name || ''
            }
          }
        }
      ]
    })
  }

  if (formData.auftrag_26_11?.enabled) {
    auftraege.push({
      kennung: '26.11',
      felder: []
    })
  }

  if (formData.auftrag_26_12?.enabled) {
    auftraege.push({
      kennung: '26.12',
      felder: [
        {
          kennung: '26.13',
          werte: { signal: formData.auftrag_26_12?.field_26_13_signal || '' }
        }
      ]
    })
  }

  return {
    kennung: '26',
    frontendId,
    auftraege
  }
}
